import { InjectionToken } from '@angular/core';
import { EmployeeHierarchiesPort } from './employee-hierarchies.port';

export const EMPLOYEE_HIERARCHIES_PORT = new InjectionToken<EmployeeHierarchiesPort>('EMPLOYEE_HIERARCHIES_PORT');
